import { MESSAGE_SEND_STATUS } from '@/helpers/livechatConstants';

export default (msg, $store) => {
  $store.dispatch('setMessageSendStatus', {
    conversationId: msg.original_message.cid,
    ref: msg.ref,
    sendStatus: MESSAGE_SEND_STATUS.RECEIVED,
  });
};
